import { TimePicker } from "antd";
import { DatePickerRules } from "../../types/field";
import dayjs from "dayjs";
import { Controller } from "react-hook-form";
import { useEffect } from "react";
import React, { useState } from "react";
import { disabledDate } from "../../utils/utils";

type TImePickerProps = {
  title: string;
  placeholder?: string;
  onChange?: any;
  disabled?: boolean;
  data?: any;
  className?: string;
  showTime?: boolean;
  clearIcon?: boolean;
  rules?: DatePickerRules;
  register?: any;
  id: string;
  name: string;
  setValue?: any;
  control: any;
  warning?: string;
  currentValue?:any;
};

const CustomTImePicker: React.FC<TImePickerProps> = ({
  title,
  data,
  onChange,
  disabled,
  rules,
  id,
  name,
  control,
  setValue,
  warning

}) => {
  const [compDate, setCompDate] = useState<dayjs.Dayjs | undefined>();
 

  useEffect(() => {
    console.log(data,'data')
    if (data && setValue) {
      setValue(name, data);
      onChange(data);
    }
    if(data === undefined) {
      setCompDate(undefined);
    }
  }, [data]);
  



  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: rules?.mandatory ? `${title} is required` : false,
      }}
      render={({ field, fieldState, formState }) => (
        <>
          <TimePicker
            // format={format}
            showSecond={false}
            disabledDate={(current) => disabledDate(current, rules)}
            disabled={disabled}
            style={{ width: "100%" }}
            format="HH:mm"
            id={id}
            {...field}
            onChange={(value) => {
              let date =
                value === null ? "" : dayjs(value).format("HH:mm");
              field.onChange(date);
              setCompDate(value === null ? undefined : dayjs(value));
              field.value = date;
              onChange(value)
            }}
            value={compDate}
          />
          {fieldState.error?.message && (
            <div className="ant-form-item-explain-error">
              {fieldState.error?.message}
            </div>
          )}
          {warning && (
            <div className="ant-form-item-explain-warning">
              {warning}
            </div>
          )}
        </>
      )}
    />
  );
};


export default CustomTImePicker;
